import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { StoreModule } from '@ngrx/store'
import { EffectsModule } from '@ngrx/effects'
import * as fromExtra from './reducer'
import { ExtraEffects } from './effects'
import { ExtraService } from './service'
import { ExtrasGuard } from './guard'

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('extra', fromExtra.extraReducer),
    EffectsModule.forFeature([ExtraEffects]),
  ],
  declarations: [],
  providers: [ExtrasGuard, ExtraService],
})
export class ExtrasStoreModule {}
